import { gql, type Variables } from 'graphql-request'

import { client } from '@/proxy/client'
import { MutationDataError } from '@/resources/types'
import { useMutation } from '@/proxy/react-query'

import {
  SaveEditFakedoorMutationData,
  SaveEditFakedoorMutationVariables,
} from './types'

export const SAVE_EDIT_FAKEDOOR = gql`
  mutation SaveEditFakedoor($value: Float!) {
    saveEditFakedoor(value: $value) {
      ok
    }
  }
`

export const useSaveEditFakedoor = () =>
  useMutation<
    SaveEditFakedoorMutationData,
    MutationDataError,
    SaveEditFakedoorMutationVariables
  >({
    mutationFn: (variables: SaveEditFakedoorMutationVariables) =>
      client.request(SAVE_EDIT_FAKEDOOR, variables as unknown as Variables),
  })
